import {instance} from '../index';

export const exchangeOffersAPI = {
    getExchangeOffers (historical) {
      return instance.get(`flyjets-exchange/admin-dasboard-offers?historical=${historical}`);
    },
    getBidsByOfferId (offerId) {
      return instance.get(`flyjets-exchange/admin-dasboard-offer-bid/${offerId}`);
    },
    deleteOfferById (offerId) {
      return instance.delete('flyjets-exchange/delete-offer', { data: { id: offerId } });
    },
    cancelBidById (bidId) {
      return instance.put(`flyjets-exchange/cancel-bid/${bidId}`);
    },
    getTransfers (status) {
      return instance.get(`flyjets-exchange/offer-transfers?status=${status}`);
    },
    transferMoneFromEscrowToPlatform (transferId) {
      return instance.put(`stripe/transer-from-escrow-to-platform/${transferId}`);
    },
    transferMoneToSellerAndOperator (transferId) {
      return instance.put(`stripe/transer-to-seller-and-operator/${transferId}`);
    },
  }